import { post } from "./hooks";

const HANDOFF_PARAM = "code";
// Never accepted any more, but stripped so an old-style redirect does not
// leave a token in the address bar or browser history.
const LEGACY_TOKEN_PARAMS = ["access_token", "token"];

/**
 * Reads the single-use handoff code the API attaches when it redirects back
 * from Google or Microsoft, and removes it (and any legacy token parameter)
 * from the address bar and history entry.
 *
 * The API is expected to put the code in the URL fragment (#code=...), which
 * browsers never send to servers or in Referer headers. ?code= is also read
 * so the two deploys do not have to land at the same instant.
 */
export const takeOAuthHandoffCode = (): string | null => {
  const url = new URL(window.location.href);
  const fragment = new URLSearchParams(url.hash.replace(/^#/, ""));
  const code =
    fragment.get(HANDOFF_PARAM) || url.searchParams.get(HANDOFF_PARAM);

  const sensitiveParams = [HANDOFF_PARAM, ...LEGACY_TOKEN_PARAMS];
  const hadSensitiveParams = sensitiveParams.some(
    (param) => fragment.has(param) || url.searchParams.has(param),
  );
  if (hadSensitiveParams) {
    sensitiveParams.forEach((param) => {
      fragment.delete(param);
      url.searchParams.delete(param);
    });
    const remainingFragment = fragment.toString();
    window.history.replaceState(
      window.history.state,
      "",
      `${url.pathname}${url.search}${remainingFragment ? `#${remainingFragment}` : ""}`,
    );
  }
  return code;
};

/**
 * Exchanges a handoff code in a POST body. For a sign-in the API responds with
 * the same payload as POST /auth/bpi/signin; for a mailbox connection it
 * responds with { platformID, platform, email }.
 */
export const exchangeOAuthHandoffCode = (code: string) =>
  post("auth", "oauth/exchange", { code });
